<div class="criterion-editor">

  <div class="criterion {{criterion.type}}">
    <div class="circle {{criterion.type + 'Circle'}}"></div>
    <img class="image" *ngIf="criterion.type != 'none'" src="assets/trialcuration/entrance-yes.svg"/>
    <img class="image" *ngIf="criterion.type == 'none'" src="assets/trialcuration/entrance-no.svg"/>

    <select class="select-criterion-operator" [(ngModel)]="criterion.type">
      <option value="any">At least one of the following rows must yield true</option>
      <option value="all">All of the following rows must yield true</option>
      <option value="none">None of the following rows must yield true</option>
    </select>
    <div class="spacer"></div>
    <i class="fa fa-trash" (click)="onDeleteMe()" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Dëlete'"></i>
    <i class="fa fa-clone" (click)="onCloneMe()" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Clone'"></i>
    <i class="fa fa-bars" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Drag to change priority'"></i>
  </div>

  <div class="conditions" *ngIf="criterion && criterion.conditions" [dragula]=listName [dragulaModel]="criterion.conditions">
    <gen-condition-editor *ngFor="let condition of criterion.conditions; let first = first"
                          [condition]="condition"
                          [first]="first"
                          [type]="criterion.type"
                          (cloneMe)="duplicateCondition($event)"
                          (deleteMe)="deleteCondition($event)"
    ></gen-condition-editor>

    <div class="condition-row">
      <div class="leftMargin">
        <div class="topLeft"></div>
        <div class="topRight"></div>
      </div>
      <div class="add-condition-button" (click)="addCondition()">Add Row</div>
    </div>

  </div>
</div>
